import {
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpEvent,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  catchError,
  finalize,
  shareReplay,
  switchMap,
  throwError,
  Observable,
} from 'rxjs';
import { LoginResponseDto } from 'sham-components/shared/models/auth';
import { AuthService } from './auth.service';
import { LanguageService } from 'sham-components/services';

let refreshRequest$: Observable<LoginResponseDto> | null = null;

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const langService = inject(LanguageService);
  const accessToken = sessionStorage.getItem('accessToken');
  const currentLang = langService.currentLang();

  let headers: { [name: string]: string | string[] } = {
    'Accept-Language': currentLang,
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const authReq = req.clone({
    setHeaders: headers,
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const isAuthRequest =
        req.url.includes('/api/v1/auth/login') ||
        req.url.includes('/api/v1/auth/refresh-token');
      if (error.status === 401 && !isAuthRequest) {
        return handle401Error(authReq, next, authService);
      }
      return throwError(() => error);
    }),
  );
};

function handle401Error(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authService: AuthService,
): Observable<HttpEvent<unknown>> {
  if (!refreshRequest$) {
    refreshRequest$ = authService.refreshToken().pipe(
      finalize(() => (refreshRequest$ = null)),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
  }

  return refreshRequest$.pipe(
    switchMap((response) =>
      next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${response.accessToken}` },
        }),
      ),
    ),
  );
}
